import store from 'store';
import { Yubinuki, Procedure, Ito, SasiType, NeedleMode } from './Yubinuki';

interface StorageInfo {
    key: string,
    hasData: boolean,
    title: string,
};

export const slotKeys = ['slot01', 'slot02', 'slot03', 'slot04', 'slot05'];

function list(): Array<StorageInfo> {
    return slotKeys.map((key) => {
        let data = store.get(key)
        if (data) {
            return { key: key, hasData: true, title: data.title };
        } else {
            return { key: key, hasData: false, title: "" };
        }
    });
};

function load(key: string): { yubinuki: Yubinuki, title: string} | undefined {
    if (!slotKeys.includes(key)) {
        console.warn('Unexpected key.');
        return undefined;
    }
    let data = store.get(key);
    if (data === undefined) {
        console.warn('Loaded undefined.');
        return undefined;
    }
    if (data["komaArray"]) {
        return { yubinuki: convertFromOldType(data), title: data["title"] };
    }
    return { yubinuki: data.yubinuki, title: data.title };
}

function save(key: string, data: { yubinuki: Yubinuki, title: string }) {
    if (!slotKeys.includes(key)) {
        console.warn('Unexpected key.');
        return;
    }
    store.set(key, data);
}

function convertFromOldType(data: any): Yubinuki {
    let procedures: Array<Procedure> = []
    let komaArray = data["komaArray"];
    let komaLength = komaArray.length;
    for (var i = 0; i < komaLength; i++) {
        let koma = komaArray[i];
        let itos: Array<Ito> = [];
        let itoArray = koma["itoArray"];
        let itoLength = itoArray.length;
        for (var j = 0; j < itoLength; j++) {
            let ito = itoArray[j];
            itos.push({ color: ito["color"], rounds: parseInt(ito["rounds"]) });
        }
        procedures.push({
            offset: parseInt(koma["offset"]),
            sasiType: convertSasiTypeFromOldType(koma["sasiType"]),
            matomeSasi: koma["komaKagari"],
            groupNo: 0, // 新しい概念なので固定
            connectedRounds: 1, // 新しい概念なので固定
            itos: itos,
        })
    }
    return {
        koma: parseInt(data["komaNum"]),
        tobi: parseInt(data["tobiNum"]),
        needleMode: komaLength === 1 ? NeedleMode.SINGLE : convertNeedleModeFromOldType(data["needleMode"]),
        resolutionAuto: true,
        resolution: 20,
        procedures: procedures,
    }
}

function convertSasiTypeFromOldType(sasiType: string): number {
    if (sasiType === "NAMI") {
        return SasiType.NAMI;
    } else {
        return SasiType.HIRAKI;
    }
}

function convertNeedleModeFromOldType(needleMode: string): number {
    if (needleMode === "MULTIPLE") {
        return NeedleMode.MULTIPLE;
    } else {
        return NeedleMode.SINGLE;
    }
}

export default {
    list: list,
    load: load,
    save: save,
};
